
import { Pilot, Tag, Zone } from '@/generated-clients/myTrips';
import { FilterOptions } from '@/utils/types';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const SettingsModule = namespace('Settings');

@Component({
  name: 'ActiveFiltersList',
  components: {
  }
})
export default class ActiveFiltersList extends Vue {
  @SettingsModule.Getter('getTags')
  private tags: Tag[];

  @SettingsModule.Getter('getPilots')
  private pilots: Pilot[];

  @SettingsModule.Getter('getZones')
  private zones: Zone[];

  @Prop({ required: true })
  private filters: FilterOptions

  get tag() {
    const { tagId } = this.filters;
    return this.filters.tagId && this.tags.find(t => t.id === tagId).name;
  }

  get pilot() {
    const { pilotId } = this.filters;
    return this.filters.pilotId && this.pilots.find(t => t.id === pilotId).firstname;
  }

  get zone() {
    const { zoneId } = this.filters;
    return this.filters.zoneId && this.zones.find(t => t.id === zoneId).name;
  }
}
